import { SliceZone } from '@prismicio/react';

import { ReactElement } from 'react';

import { PrismicProductPageQuery } from '@prismic/gqlTypes/prismicOperations';

import { components } from './Slices';

interface Props {
  productDetails: PrismicProductPageQuery['product'] | null;
}

export function ProductStandardBody({ productDetails }: Props): ReactElement {
  return <SliceZone slices={productDetails?.body} components={components} />;
}
